import * as React from 'react';
import { cn } from '@/lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface PageSectionProps {
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  asCard?: boolean;
}

export function PageSection({
  title,
  description,
  actions,
  children,
  className,
  contentClassName,
  asCard = true,
}: PageSectionProps) {
  if (!asCard) {
    return (
      <section className={cn('space-y-3', className)}>
        {(title || description || actions) ? (
          <div className="flex flex-wrap items-start justify-between gap-2">
            <div className="space-y-1">
              {title ? <h2 className="text-lg font-semibold">{title}</h2> : null}
              {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
            </div>
            {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
          </div>
        ) : null}
        <div className={contentClassName}>{children}</div>
      </section>
    );
  }

  return (
    <Card className={className}>
      {(title || description || actions) ? (
        <CardHeader className="space-y-1">
          <div className="flex flex-wrap items-start justify-between gap-2">
            <div className="space-y-1">
              {title ? <CardTitle>{title}</CardTitle> : null}
              {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
            </div>
            {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
          </div>
        </CardHeader>
      ) : null}
      <CardContent className={cn('space-y-3', contentClassName)}>{children}</CardContent>
    </Card>
  );
}

